var map = {
	"./saffronfiles/config/modules/locale.js": 94145,
	"./saffronfiles/config/modules/router.js": 25591,
	"./saffronfiles/config/modules/style.js": 39244,
	"./saffronfiles/config/modules/user.js": 88050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10839;